import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import localeDeAt from '@angular/common/locales/de-AT';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeDeAt, 'de-at');
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
